import { useEffect, useState } from "react";
import Api from '../api/api';
import { useParams, useHistory } from "react-router-dom";
import { RoiForm } from "./roiForm";
import arrayUtilities from "../../utilities/arrayUtilities";
import stringHelpers from "../../utilities/stringHelpers";

export default function EditCameraRoi(props) {
    const history = useHistory();
    const { siteId, cameraId, roiId } = useParams();
    const [image, setImage] = useState(null);
    const [points, setPoints] = useState([]);
    const [roiName, setRoiName] = useState("");
    const [polygon, setPolygon] = useState("");
    const [data, setData] = useState(null);
    const [ratio, setRatio] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);

    const handleMouseDown = (event) => {        
        const rect = event.target.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        setPoints((prevPoints) => [...prevPoints, { x: x / ratio, y: y / ratio }]);
    };

    useEffect(() => {
        Api.getCameraRoiById(
            props.organisationId, cameraId, roiId,
            data => {
                Api.getCamera(
                    result => {
                        setImageUrl(result.imageUrl)
                        setData(data)
                        setRoiName(data.name);
                    },
                    error => console.log(error),
                    props.organisationId,
                    cameraId,
                    props.token
                )
                
            },
            error => console.log(error),
            props.token
        )
    }, [])

    useEffect(() => {
        if (data && !stringHelpers.isNullOrEmpty(imageUrl)) {
            const _image = new Image();
            _image.src = imageUrl
            setImage(_image)
            _image.onload = () => {
                const container = document.querySelector(".edit-image-container");
                if (container) {
                    const _ratio = container.clientWidth / _image.naturalWidth;
                    setRatio(_ratio)
                    const _points = stringHelpers.fetchPolygonPoints(data.polygon);
                    if (!arrayUtilities.isNullOrEmpty(_points)) {
                        setPoints(_points);
                    }
                }
            }
            window.addEventListener("resize", () => {
                if (_image) {
                    const container = document.querySelector(".edit-image-container");
                    if (container) {
                        const _ratio = container.clientWidth / _image.naturalWidth;
                        setRatio(_ratio)
                    }
                }
            })
        }
    }, [data])

    const handleSave = () => {
        const payloadString = `POLYGON((${points.reduce((acc, curr) => {
            acc += `${ curr.x } ${ curr.y }, `
            return acc
        }, "")}${ points[0].x } ${ points[0].y }))`
        Api.editCameraRoi(
            props.organisationId, cameraId, roiId, roiName, payloadString,
            () => history.push(`/organisation/${ props.organisationId }/site/${ siteId }/camera/${ cameraId }`),
            error => console.log(error),
            props.token
        )
    }    
    
    return image && <RoiForm
        title="Edit Region of Interest"
        onCancel={ () => history.push(`/organisation/${ props.organisationId }/site/${ siteId }/camera/${ cameraId }`) }
        onSave={ handleSave }
        roiName={ roiName }
        polygon={ polygon }
        setPolygon={ setPolygon }
        setName={ setRoiName }
        imageSource={image.src}
        handleImageClick={e => handleMouseDown(e)}
        points={points}
        setPoints={setPoints}
        data={data}
        ratio={ratio}
    />
}